class StripeConnectSuccessCtrl {
  constructor($scope, $state, $stateParams) {
    if ($stateParams.error) {
      $scope.error = $stateParams.error_description;
    } else {
      $state.go('app.settings', {
        stripeUserId: $stateParams.stripe_user_id
      });
    }
  }
}

StripeConnectSuccessCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams'
];

export default StripeConnectSuccessCtrl;



// WEBPACK FOOTER //
// ./src/components/stripeConnectSuccess/stripeConnectSuccessCtrl.js